export default __webpack_public_path__ + "static/media/feather_minus-circle-disable.e52e73e7.svg";